export default {
  wishlist_buttons: {
    add_product: "Tilføj til ønskeliste",
    remove_product: "Fjern fra ønskeliste",
    product_in_wishlist: "I ønskeliste",
    view_wishlist: "Se ønskeliste",
    clear_wishlist: "Ryd ønskeliste",
    wishlist: "Ønskeliste",
    save_for_later: "Gem til senere",
  },
  wishlist_page: {
    title: "Ønskeliste",
    login_callout_html:
      "For at gemme din favoritter skal du <a href='{{ login_url }}'>log ind</a> eller <a href='{{ register_url }}'>oprette dig</a>.",
    wishlist_empty_callout_html: "Din ønskeliste er tom",
    wishlist_empty_cta: "Opdag mere",
    product_removed_html: "Produkt ikke længere tilgængeligt",
    view_product: "Se produkt",
    remove_product: "Fjern",
    add_all_to_cart: "Tilføj ønskeliste til kurv",
  },
  wishlist_product: {
    add_to_cart: "Tilføj til kurv",
    select_option: "Vælg {{ name }}",
    sold_out: "Udsolgt",
    unavailable: "Utilgængelig",
    view_product: "Se produkt",
    from_price_html: "Fra {{ price }}",
    quantity: "Antal",
  },
  wishlist_share: {
    button_label: "Del dine favoritter",
    link_copied: "Link kopieret",
    share_title: "Min ønskeliste",
    share_message: "Her er et link til min ønskeliste.",
  },
};
